<div class="call-user-con">
    <div class="callTo">
        <img class="portrait" src="{{ToUserSmallDataUrl}}">    
    </div>
    <p class="tip mt20">向<span>“{{ToUserNickName}}”</span>发起通话</p>
    {{if IsFromFree == 1}}
        <p class="fee">免费券通话</p>
    {{else}}
        {{if ShowCallInfo=="抱歉，您当前免费通话时长已用完"}}
            <p class="fee" style="color:#FF5379">{{ShowCallInfo}}</p>
        {{else}}
            <p class="fee">{{ShowCallInfo}}</p>
        {{/if}}
    {{/if}}
</div>
<div class="call-yue">
    <h5>
        {{if OnlyFree }}
            <span>当前可通话时长：{{CanUseFreeMinute}}分钟</span>
        {{else}}
            <span>当前可通话时长：{{MaxMinutes}}分钟</span>
        {{/if}}
        <a href="./recharge.html" class="recharge-link">充值<i class="iconfont icon-gengduo-right"></i></a>
    </h5>
</div>
<div class="btn-wrap">
    {{if IsMobileOk}}
        {{if (IsShowCallBtn&&IsEnableCallBtn) && IsShowVIPBtn}}
            <a class="w180btn gradientYellowColor" href="./member.html">开通VIP获取更多时长</a>
            <a class="w180btn gradientColor dail-btn">立即拨打</a>
        {{else if (IsShowCallBtn&&IsEnableCallBtn) && !IsShowVIPBtn}}
            <a class="w360btn gradientColor dail-btn">立即拨打</a>
        {{else if (!IsShowCallBtn || !IsEnableCallBtn) && IsShowVIPBtn}}
            <a class="w360btn gradientYellowColor" href="./member.html">开通VIP获取更多时长</a>
        {{/if}}
    {{else}}
        <a class="w180btn gradientColor" href="./personal.html?type=setting&settingtype=2">绑定手机号</a>
    {{/if}}
    
</div>